<template>
  <div class="mt-4">
    <Account v-bind:AccountId="$store.getters.user.Account_Id.toString()" />
  </div>
</template>

<script>
import Account from "@/components/ManageAccounts/Account.vue";

export default {
  name: "MyAccount",
  components: {
    Account
  },
  data() {
    return {
      something: ""
    };
  },
  mounted() {},
  methods: {
    method() {}
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
